<ion-content class="register-content">
  <div class="modal-backdrop-click">
    <div class="page-container">
      <!-- Register Card -->
      <div class="register-card">
      <button
        type="button"
        class="modal-close"
        (click)="back()"
        [disabled]="load"
        [class.close-disabled]="load"
        aria-label="Fechar">
        <ion-icon name="close"></ion-icon>
      </button>
      <!-- Form Header -->
      <div class="form-header">
        <h1 class="form-title">Criar conta</h1>
        <p class="form-subtitle">Preencha seus dados para criar sua conta no iPlanta</p>
      </div>

      <!-- Form Content -->
      <form class="register-form" [class.form-disabled]="load">
        <div class="form-section">
          <h3 class="section-title">Dados do cadastro</h3>
          <div class="input-group">
            <div class="register-input" [class.input-disabled]="load">
              <ion-icon name="person-outline"></ion-icon>
              <input
                class="register-input-native"
                data-testid="register-name-input"
                name="name"
                type="text"
                placeholder="Nome completo"
                (input)="changeName()"
                [(ngModel)]="name"
                [disabled]="load"
              />
            </div>
            <div class="error-message" *ngIf="messageErrorName.status && !load">
              <ion-icon name="alert-circle-outline"></ion-icon>
              <span>{{messageErrorName.message}}</span>
            </div>
          </div>
          <div class="input-group">
            <div class="register-input" [class.input-disabled]="load">
              <ion-icon name="mail-outline"></ion-icon>
              <input
                class="register-input-native"
                data-testid="register-email-input"
                name="email"
                type="email"
                placeholder="E-mail"
                (input)="changeEmail()"
                [(ngModel)]="email"
                [disabled]="load"
              />
            </div>
            <div class="error-message" *ngIf="messageErrorEmail.status && !load">
              <ion-icon name="alert-circle-outline"></ion-icon>
              <span>{{messageErrorEmail.message}}</span>
              <p
                class="recover-link"
                (click)="requestPasswordRecover()"
                *ngIf="messageErrorEmail.message === 'Email já cadastrado no iPlanta'">
                Recupere sua senha aqui
              </p>
            </div>
          </div>
          <div class="input-group">
            <div class="register-input" [class.input-disabled]="load">
              <ion-icon name="call-outline"></ion-icon>
              <input
                class="register-input-native"
                data-testid="register-phone-input"
                name="phone"
                type="text"
                placeholder="Telefone (apenas números)"
                maxlength="15"
                (input)="changePhone()"
                [(ngModel)]="phone"
                [disabled]="load"
              />
            </div>
            <div class="error-message" *ngIf="messageErrorPhone.status && !load">
              <ion-icon name="alert-circle-outline"></ion-icon>
              <span>{{messageErrorPhone.message}}</span>
            </div>
          </div>
          <div class="input-group">
            <div class="register-input" [class.input-disabled]="load">
              <ion-icon name="lock-closed-outline"></ion-icon>
              <input
                class="register-input-native"
                data-testid="register-password-input"
                name="password"
                [attr.type]="showPassword ? 'text' : 'password'"
                placeholder="Senha"
                (input)="validatePassErrors()"
                [(ngModel)]="password"
                [disabled]="load"
              />
              <ion-button fill="clear" (click)="showPassword = !showPassword" type="button" class="register-input-toggle" style="height: 30px;" [disabled]="load">
                <ion-icon [hidden]="showPassword" name="eye-off-outline"></ion-icon>
                <ion-icon [hidden]="!showPassword" name="eye-outline"></ion-icon>
              </ion-button>
            </div>
            <div class="password-requirements" *ngIf="password && !passwordIsValid && !load">
              <ng-container *ngFor="let message of errorMessages; let i = index">
                <ion-chip
                  *ngIf="!errorMessagesValidity[i]"
                  color="medium"
                  class="requirement-chip">
                  <ion-icon name="close-circle"></ion-icon>
                  <ion-label>{{message}}</ion-label>
                </ion-chip>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <ion-button
            [disabled]="!isFormComplete() || load"
            class="next-button"
            data-testid="register-submit-btn"
            [class.loading]="load"
            (click)="nextPage()"
            expand="block">
            <ion-spinner *ngIf="load" name="crescent" slot="start"></ion-spinner>
            <ion-icon *ngIf="!load" name="person-add-outline" slot="start"></ion-icon>
            {{ load ? loadingMessage : 'Criar conta' }}
          </ion-button>

          <div class="login-divider" *ngIf="!load">
            <span>ou</span>
          </div>

          <ion-button
            *ngIf="!load"
            class="google-button"
            (click)="loginWithGoogle()"
            [disabled]="loadGoogle"
            expand="block"
            fill="outline">
            <ion-spinner *ngIf="loadGoogle" name="crescent" class="google-spinner"></ion-spinner>
            <img *ngIf="!loadGoogle" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" class="google-icon" />
            {{ loadGoogle ? 'Entrando...' : 'Continuar com Google' }}
          </ion-button>
        </div>
      </form>
    </div>
  </div>
  </div>
</ion-content>
